import { Injectable } from "@angular/core";
import { AppConfig } from "../../app.config";
import { HttpClient } from "@angular/common/http";
import { WorkflowContent, Workflow, WorkflowStatus } from "../../models/workflow";

@Injectable({ providedIn: 'root' })
export class WorkflowService {

  apiVersion = `v${AppConfig.data['apiVersion']}`;
  service = AppConfig.data['services']['workflow'];
  endpoint = `${this.service}/${this.apiVersion}`

  constructor(
    private http: HttpClient
  ) { }

  searchWorkflows(params?: { unpaged?: string, title?: string, sort?: string, page?: string }) {
    return this.http.get<WorkflowContent>(`${this.endpoint}/workflows`, { params })
  }

  addWorkflowtoContent(contentid: string, workflowId: string, type: string) {
    return this.http.put(`${AppConfig.data['services']['cms']}/${this.apiVersion}/${type}/${contentid}/add/workflow/${workflowId}`, null)
  }

  segregateContent(id: string, item: 'page' | 'homepage') {
    let endpoint = `${AppConfig.data['services']['cms']}/${this.apiVersion}`;
    if (item == 'page') {
      return this.http.put(`${endpoint}/pages/${id}/segregate/workflow`, null)
    } else {
      return this.http.put(`${endpoint}/homepages/${id}/segregate/workflow`, null)
    }
  }

  removeSegregateContent(id: string, item: 'page' | 'homepage') {
    let endpoint = `${AppConfig.data['services']['cms']}/${this.apiVersion}`;
    if (item == 'page') {
      return this.http.put(`${endpoint}/pages/${id}/remove/segregate/workflow`, null)
    } else {
      return this.http.put(`${endpoint}/homepages/${id}/remove/segregate/workflow`, null)
    }
  }

  getWorkflow(id: string) {
    return this.http.get<Workflow>(`${this.endpoint}/workflows/${id}`,)
  }

  getWorkflowsCIList() {
    return this.http.get<Workflow[]>(`${this.endpoint}/workflows/list`);
  }

  changePhase(phaseId: string, comment: string, change: 'approve' | 'reprove', query?: { considerCriticalAnalysis?: string, considerTemporaryCorrective?: string }) {
    return this.http.get(`${this.endpoint}/workflows/phase/${change}/${phaseId}/${comment}`, { params: query })
  }

  getPageStatus(id: string) {
    return this.http.get<WorkflowStatus>(`${this.endpoint}/workflows/flow/${id}`)
  }

  getFlowDefinition(itemId: string, itemType: string, workflowDefinitionId?: string) {
    const params: Record<string, string> = { itemId, itemType };
    if (workflowDefinitionId) {
      params.workflowDefinitionId = workflowDefinitionId;
    }
    return this.http.get<WorkflowStatus>(`${this.endpoint}/workflows/flow/definition`, { params });
  }

  deletePhaseWorkflow(phaseId: string) {
    return this.http.delete(`${this.endpoint}/workflows/phase/definition/${phaseId}`)
  }

  getWorflowPhases(workflowId: string, responsible: boolean) {
    return this.http.get(`${this.endpoint}${responsible ? '/responsible' : ''}/phases/${workflowId}`);
  }

  sendCallNextPhase(callWorkflowId: string, responsibleComments: string) {
    return this.http.post(`${this.endpoint}/workflows/phase/approve/${callWorkflowId}`, { responsibleComments })
  }

  sendCallPreviousPhase(callWorkflowId: string, responsibleComments: string) {
    return this.http.post(`${this.endpoint}/workflows/phase/reprove/${callWorkflowId}`, { responsibleComments })
  }
}
